<!--提报项目明细-->
<template>
  <div class="InstpectDetailDiv">
    <div class="wrapper">
      <van-form disabled>
        <van-cell-group inset style="margin: 1vh 1.2vh 0vh 1.2vh">
          <span class="line-span">
            <van-icon class="lable_icon" />隐患描述
            <label style="padding: 10px 15px; font-size: 16px" class="lab"
              >{{ pageConfig.itemInfo.trouble_content }}
            </label>
          </span>
          <span class="line-span">
            <van-icon class="lable_icon" />隐患区域
            <label style="padding: 10px 15px; font-size: 16px" class="lab"
              >{{ pageConfig.itemInfo.area_name }}
            </label>
          </span>
          <span class="line-span">
            <van-icon class="lable_icon" />隐患照片
            <div
              class="img-block"
              v-for="file in pageConfig.fileList"
              @click="methods.previewPhoto(file)"
              :key="file.id"
              :title="file.name"
            >
              <div class="img-icon">
                <img src="@/assets/file-img/img.svg" height="30" />
              </div>
              <div class="img-name">
                <span>{{ file.name }}</span>
              </div>
              <div class="file-size">
                <span v-if="Number(file.file_size) / 1024 / 1024 < 1"
                  >{{ (Number(file.file_size) / 1024).toFixed(2) }}K</span
                >
                <span v-else
                  >{{
                    (Number(file.file_size) / 1024 / 1024).toFixed(2)
                  }}M</span
                >
              </div>
            </div>
          </span>
          <span class="line-span">
            <van-icon class="lable_icon" />判定结果
            <label style="padding: 10px 15px; font-size: 16px" class="lab">
              <van-tag
                v-if="pageConfig.itemInfo.judge_result == 'N'"
                size="medium"
                type="default"
              >
                无风险
              </van-tag>
              <van-tag
                v-if="pageConfig.itemInfo.judge_result == 'Y'"
                size="medium"
                type="danger"
              >
                有风险
              </van-tag>
            </label>
          </span>
          <span
            class="line-span"
            v-if="pageConfig.itemInfo.judge_result == 'Y'"
          >
            <van-icon class="lable_icon" />风险等级
            <label style="padding: 10px 15px; font-size: 16px" class="lab">
              <van-tag
                v-if="pageConfig.itemInfo.trouble_level == 'H'"
                size="medium"
                type="danger"
              >
                高
              </van-tag>
              <van-tag
                v-if="pageConfig.itemInfo.trouble_level == 'M'"
                size="medium"
                type="warning"
              >
                中
              </van-tag>
              <van-tag
                v-if="pageConfig.itemInfo.trouble_level == 'L'"
                size="medium"
                type="primary"
              >
                低
              </van-tag>
            </label>
          </span>
          <span class="line-span">
            <van-icon class="lable_icon" />风险判定人
            <label style="padding: 10px 15px; font-size: 16px" class="lab"
              >{{ pageConfig.itemInfo.trouble_emp_name }}
            </label>
          </span>
          <span class="line-span">
            <van-icon class="lable_icon" />整改指令
            <label style="padding: 10px 15px; font-size: 16px" class="lab"
              >{{ pageConfig.itemInfo.rectify_instruction }}
            </label>
          </span>
          <span class="line-span">
            <van-icon class="lable_icon" />区域负责人
            <label style="padding: 10px 15px; font-size: 16px" class="lab"
              >{{ pageConfig.itemInfo.duty_emp_name }}
            </label>
          </span>
          <span class="line-span">
            <van-icon class="lable_icon" />验收人
            <label style="padding: 10px 15px; font-size: 16px" class="lab"
              >{{ pageConfig.itemInfo.accept_emp_name }}
            </label>
          </span>
          <span class="line-span">
            <van-icon class="lable_icon" />验收结果
            <label style="padding: 10px 15px; font-size: 16px" class="lab">
              <van-tag
                v-if="pageConfig.itemInfo.accept_result == 'Y'"
                size="medium"
                type="success"
              >
                已通过
              </van-tag>
              <van-tag
                v-if="pageConfig.itemInfo.accept_result == 'N'"
                size="medium"
                type="danger"
              >
                已驳回
              </van-tag>
            </label>
          </span>
          <span class="line-span">
            <van-icon class="lable_icon" />驳回原因
            <label style="padding: 10px 15px; font-size: 16px" class="lab"
              >{{ pageConfig.itemInfo.reject_reason }}
            </label>
          </span>
          <span class="line-span">
            <van-icon class="lable_icon" />结案时间
            <label style="padding: 10px 15px; font-size: 16px" class="lab"
              >{{ methods.convertTime(pageConfig.itemInfo.end_time) }}
            </label>
          </span>
          <span class="line-span">
            <van-icon class="lable_icon" />奖惩单号
            <label style="padding: 10px 15px; font-size: 16px" class="lab"
              >{{ pageConfig.itemInfo.award_series_code }}
            </label>
          </span>
          <span class="line-span">
            <van-icon class="lable_icon" />整改措施
            <label style="padding: 10px 15px; font-size: 16px" class="lab"
              >{{ pageConfig.itemInfo.rectify_measure }}
            </label>
          </span>
          <span class="line-span">
            <van-icon class="lable_icon" />整改照片

            <div
              class="img-block"
              v-for="file in pageConfig.rectifyFileList"
              @click="methods.previewPhoto(file)"
              :key="file.id"
              :title="file.name"
            >
              <div class="img-icon">
                <img src="@/assets/file-img/img.svg" height="30" />
              </div>
              <div class="img-name">
                <span>{{ file.name }}</span>
              </div>
              <div class="file-size">
                <span v-if="Number(file.file_size) / 1024 / 1024 < 1"
                  >{{ (Number(file.file_size) / 1024).toFixed(2) }}K</span
                >
                <span v-else
                  >{{
                    (Number(file.file_size) / 1024 / 1024).toFixed(2)
                  }}M</span
                >
              </div>
            </div>
          </span>
          <span class="line-span">
            <van-icon class="lable_icon" />当前状态
            <label style="padding: 10px 15px; font-size: 16px" class="lab">
              <van-tag
                v-if="pageConfig.itemInfo.current_status == '1'"
                size="medium"
                type="default"
              >
                待判定
              </van-tag>
              <van-tag
                v-if="pageConfig.itemInfo.current_status == '2'"
                size="medium"
                type="warning"
              >
                整改中
              </van-tag>
              <van-tag
                v-if="pageConfig.itemInfo.current_status == '3'"
                size="medium"
                type="warning"
              >
                验收中
              </van-tag>
              <van-tag
                v-if="pageConfig.itemInfo.current_status == '4'"
                size="medium"
                type="success"
              >
                已结案
              </van-tag>
            </label>
          </span>
        </van-cell-group>
      </van-form>
    </div>
  </div>
</template>
<script>
import { reactive, ref, onMounted } from 'vue'
import { GetSafetyInspectItemPageList } from '@/api/oacks.js'
import { DownloadBase64, GetFileList } from '@/api/oaApi.js'
import { Toast, ImagePreview } from 'vant'
import { useRoute } from 'vue-router'
import ChangeTitle from "@/utils/changeTitle";
import moment from 'moment'
export default {
  setup(props, { emit }) {
    const route = useRoute()
    //页面参数
    const pageConfig = reactive({
      itemId: '',
      itemInfo: {},
      fileList: [],
      rectifyFileList: [],
    })
    //内置函数
    const methods = {
      init: function () {        
        ChangeTitle.setTitle('隐患明细')
        pageConfig.itemId = route.params.itemId
        //获取提报列表
        methods.getItemList()
      },

      //时间转换
      convertTime: function (time) {
        if (time) {
          return moment(time).format('YYYY-MM-DD HH:mm:ss')
        }
        return ''
      },
      //获取提报列表
      getItemList: function () {
        if (pageConfig.itemId) {
          let param = {
            pageIndex: 1,
            pageSize: 1000,
            item_id: pageConfig.itemId,
          }
          GetSafetyInspectItemPageList(param).then((res) => {
            if (res.code == 200) {
              if (res.rows.length > 0) {
                pageConfig.itemInfo = res.rows[0]
                //加载附件列表
                methods.loadFileList(res.rows[0].trouble_file_id)
                //加载整改附件列表
                methods.loadRectifyFileList(res.rows[0].rectify_file_id)
              }
            }
          })
        }
      },
      //加载附件列表
      loadFileList: function (ids) {
        if (ids == '' || ids == null) {
          return
        }
        GetFileList(ids.split(',')).then((res) => {
          if (res.code !== 200) {
            Toast(res.msg)
            return
          }
          res.data.forEach((item) => {
            //是否图片
            if (methods.verifySuffix(item.extension)) {
              pageConfig.fileList.push({
                id: item.id,
                name: item.file_name,
                extension: item.extension,
                file_size: item.file_size,
              })
            }
          })
        })
      },
      //加载整改附件列表
      loadRectifyFileList: function (ids) {
        if (ids == '' || ids == null) {
          return
        }
        GetFileList(ids.split(',')).then((res) => {
          if (res.code !== 200) {
            Toast(res.msg)
            return
          }
          res.data.forEach((item) => {
            //是否图片
            if (methods.verifySuffix(item.extension)) {
              pageConfig.rectifyFileList.push({
                id: item.id,
                name: item.file_name,
                extension: item.extension,
                file_size: item.file_size,
              })
            }
          })
        })
      },
      //预览图片
      previewPhoto: function (item) {
        DownloadBase64(item.id.split(',')).then((res) => {
          if (res.code !== 200) {
            Toast(res.msg)
            return
          }
          let url =
            'data:image/' +
            item.extension.replace('.', '') +
            ';base64,' +
            res.data[0].base64
          let arr = []
          arr.push(url)
          ImagePreview({ images: arr, closeable: true })
        })
      },
      //验证是否图片
      verifySuffix(imageName) {
        const suffix = `(bmp|jpg|png|tif|gif|pcx|tga|exif|fpx|svg|psd|cdr|pcd|dxf|ufo|eps|ai|raw|WMF|webp|jpeg)`
        const regular = new RegExp(`.*\.${suffix}`)
        return regular.test(imageName)
      },
    }
    onMounted(() => {
      methods.init()
    })
    return {
      pageConfig,
      methods,
    }
  },
}
</script>
<style scoped lang="scss">
.InstpectDetailDiv {
  .value-label {
    label {
      padding: 10px 15px;
      font-size: 14px;
    }
  }
  .line-span {
    margin-left: 1vh;
    margin-top: 2vh;
    display: block;
    color: #999;
    font-size: 13px;
  }
  .lab {
    padding: 0 !important;
    display: inline-block;
    width: 98%;
    height: auto;
    word-wrap: break-word;
    margin: 0 5px;
    color: #000;
  }

  .img-block,
  .file-block {
    cursor: pointer;
    margin: 2px;
    width: 100%;
    height: 30px;
    padding: 5px 0;
    text-align: center;
    display: flex;
    flex-wrap: nowrap;
    justify-content: flex-start;

    .img-icon,
    .file-icon {
      width: 50px;
      margin: 3px 0;
    }

    .img-name,
    .file-name {
      width: calc(100% - 120px);
      text-align: left;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      font-size: 10px;
      line-height: 36px;
    }

    .file-size {
      line-height: 36px;
      font-size: 8px;
      width: 90px;
      color: #9e9e9e;
    }
    .file-download {
      line-height: 36px;
      width: 30px;
      color: #0089ff;
    }
  }
}
</style>
